export enum Gender {
  Male = 'male',
  Female = 'female',
  NonBinary = 'nonbinary',
}

export const GENDER_I18N = {
  [Gender.Female]: 'Weiblich',
  [Gender.Male]: 'Männlich',
  [Gender.NonBinary]: 'Divers',
};
